// import React, { useState, useEffect, useMemo } from "react";
// import { styled } from "@mui/material/styles";
// import { Box, Divider, List, Typography } from "@mui/material";
// import MuiDrawer from "@mui/material/Drawer";
// import CssBaseline from "@mui/material/CssBaseline";
// import { Link, useLocation, Outlet } from "react-router-dom";
// import { useAuth } from "../../hooks/useAuth";
// import CustomListItem from "./CustomListItem";
// import ScrollableList from "./ScrollableList";
// import PawnRoutes from "../../menu-items/Pawn";
// import CarRoutes from "../../menu-items/Car";
// import LandRoutes from "../../menu-items/Land";
// import SuperAdminRoutes from "../../menu-items/SuperAdmin";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Logo from "../../assets/images/Logo.png";
// import "../../assets/css/drawer.css";
// import Navbar from "./Navbar";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";

// const drawerWidth = 300;

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
//   boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.1)",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(4)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: "100px",
//   },
//   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const DrawerComponent = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// export default function MiniDrawer(overdueData) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const { packageTypes } = useAuth();

//   const location = useLocation();

//   // const [open, setOpen] = useState(true);
//   const [open, setOpen] = useState(false);
//   const [activeMenu, setActiveMenu] = useState("");
//   const handleDrawerToggle = () => {
//     setOpen(!open);
//   };
//   const path = location.pathname;
//   let currentRoutes = [];

//   if (packageTypes.includes(1) && path.startsWith("/pawn")) {
//     currentRoutes = PawnRoutes(overdueData);
//   } else if (packageTypes.includes(2) && path.startsWith("/car")) {
//     currentRoutes = CarRoutes();
//   } else if (packageTypes?.includes(3) && path.startsWith("/land")) {
//     currentRoutes = LandRoutes();
//   } else if (/*packageTypes.includes(4) && */ path.startsWith("/admin")) {
//     currentRoutes = SuperAdminRoutes();
//   }

//   console.log(currentRoutes);
//   const filteredRoutes = useMemo(() => {
//     return Array.isArray(currentRoutes) ? currentRoutes : [];
//   }, [packageTypes, path]);

//   const getActiveMenuItem = () => {
//     return filteredRoutes
//       .flatMap((category) => category.items)
//       .find((route) => path.startsWith(route.path));
//   };

//   useEffect(() => {
//     const activeMenuItem = getActiveMenuItem();
//     if (activeMenuItem) {
//       setActiveMenu(activeMenuItem.name);
//     } else {
//       setActiveMenu("");
//     }
//   }, [location.pathname, filteredRoutes]);

//   const handleDrawerOpen = () => {
//     setOpen(!open);
//   };

//   return (
//     <Box sx={{ display: "flex", maxWidth: "100%", minWidth: "100%" }}>
//       <CssBaseline />
//       <Navbar open={open} handleDrawerOpen={handleDrawerOpen} />
//       <DrawerComponent variant="permanent" open={open}>
//         <div className={`logo-container ${open ? "" : "drawer-closed"}`}>
//           <img src={Logo} alt="Logo" className="logo" />
//         </div>
//         <Divider sx={{ mx: 2 }} />
//         <ScrollableList>
//           {filteredRoutes.map((category) => (
//             <div key={category.title}>
//               {open && category.title !== "Dashboard" && (
//                 <Typography
//                   variant="h6"
//                   align="left"
//                   sx={{
//                     marginLeft: 3,
//                     mt: 2,
//                   }}
//                 >
//                   {category.title}
//                 </Typography>
//               )}
//               <List sx={{ mx: 2 }}>
//                 {category.items.map((route) => (
//                   <CustomListItem
//                     key={route.path}
//                     button
//                     component={Link}
//                     to={route.path}
//                     selected={
//                       activeMenu === route.name ||
//                       (route.name === "create-invoice" &&
//                         route.name === "ร้าน/บริษัท")
//                     }
//                     sx={{
//                       mt: "10px",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         width: "100%",
//                       }}
//                     >
//                       {route.icon && (
//                         <ListItemIcon
//                           className="list-item-icon"
//                           sx={{
//                             justifyContent: open ? "initial" : "center",
//                             alignItems: open ? "initial" : "center",
//                             paddingRight: !open ? 3 : 0,
//                           }}
//                         >
//                           {route.icon}
//                         </ListItemIcon>
//                       )}
//                       {open && (
//                         <ListItemText
//                           primary={route.name}
//                           className="list-item-text"
//                           sx={{ mr: 2 }} // Add margin to separate text and status
//                         />
//                       )}
//                       {open && route.status && (
//                         <Box
//                           sx={{
//                             position: "relative",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             marginLeft: 2, // Adjust spacing between name and status
//                           }}
//                         >
//                           {/* Notification Badge */}
//                           {route?.status && route.status.length > 0 && (
//                             <div
//                               style={{
//                                 position: "absolute",
//                                 top: -10,
//                                 right: -8,
//                                 background: "red",
//                                 color: "white",
//                                 borderRadius: "4px",
//                                 width: "20px",
//                                 height: "20px",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 fontSize: "12px",
//                               }}
//                             >
//                               {route.status.length}
//                             </div>
//                           )}
//                         </Box>
//                       )}
//                     </Box>
//                   </CustomListItem>
//                 ))}
//               </List>
//             </div>
//           ))}
//         </ScrollableList>
//       </DrawerComponent>
//       <Box component="main" sx={{ flexGrow: 1, p: 5, width: "100%" }}>
//         <DrawerHeader />
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

import React, { useState, useEffect, useMemo } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Divider,
  List,
  Typography,
  Drawer,
  CssBaseline,
  useMediaQuery,
} from "@mui/material";
import { Link, useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import CustomListItem from "./CustomListItem";
import ScrollableList from "./ScrollableList";
import PawnRoutes from "../../menu-items/Pawn";
import CarRoutes from "../../menu-items/Car";
import LandRoutes from "../../menu-items/Land";
import SuperAdminRoutes from "../../menu-items/SuperAdmin";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Logo from "../../assets/images/Logo.png";
import "../../assets/css/drawer.css";
import Navbar from "./Navbar";

const drawerWidth = 300;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const PermanentDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    width: drawerWidth,
    "& .MuiDrawer-paper": {
      width: drawerWidth,
      boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.1)",
    },
  }),
  ...(!open && {
    width: `calc(${theme.spacing(4)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: "100px",
    },
    "& .MuiDrawer-paper": {
      width: `calc(${theme.spacing(4)} + 1px)`,
      [theme.breakpoints.up("sm")]: {
        width: "100px",
      },
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    },
  }),
}));

export default function MiniDrawer(overdueData) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { packageTypes } = useAuth();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  // ปรับ open เมื่อขนาดจอเปลี่ยน
  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  // ปิด Drawer เมื่อเปลี่ยนหน้า (มือถือเท่านั้น)
  useEffect(() => {
    if (isMobile) setOpen(false);
  }, [location.pathname, isMobile]);

  const path = location.pathname;
  let currentRoutes = [];

  if (packageTypes.includes(1) && path.startsWith("/pawn")) {
    currentRoutes = PawnRoutes(overdueData);
  } else if (packageTypes.includes(2) && path.startsWith("/car")) {
    currentRoutes = CarRoutes();
  } else if (packageTypes.includes(3) && path.startsWith("/land")) {
    currentRoutes = LandRoutes();
  } else if (path.startsWith("/admin")) {
    currentRoutes = SuperAdminRoutes();
  }

  const filteredRoutes = useMemo(() => {
    return Array.isArray(currentRoutes) ? currentRoutes : [];
  }, [packageTypes, path, currentRoutes]);

  const getActiveMenuItem = () => {
    return filteredRoutes
      .flatMap((category) => category.items)
      .find((route) => path.startsWith(route.path));
  };

  useEffect(() => {
    const activeMenuItem = getActiveMenuItem();
    if (activeMenuItem) {
      setActiveMenu(activeMenuItem.name);
    } else {
      setActiveMenu("");
    }
  }, [location.pathname, filteredRoutes]);

  const renderDrawerContent = () => (
    <>
      <div className={`logo-container ${open ? "" : "drawer-closed"}`}>
        <img src={Logo} alt="Logo" className="logo" />
      </div>
      <Divider sx={{ mx: 2 }} />
      <ScrollableList>
        {filteredRoutes.map((category) => (
          <div key={category.title}>
            {open && category.title !== "Dashboard" && (
              <Typography
                variant="h6"
                align="left"
                sx={{ marginLeft: 3, mt: 2 }}
              >
                {category.title}
              </Typography>
            )}
            <List sx={{ mx: 2 }}>
              {category.items.map((route) => (
                <CustomListItem
                  key={route.path}
                  button
                  component={Link}
                  to={route.path}
                  selected={activeMenu === route.name}
                  sx={{ mt: "10px" }}
                  onClick={() => isMobile && setOpen(false)}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {route.icon && (
                      <ListItemIcon
                        sx={{
                          justifyContent: open ? "initial" : "center",
                          alignItems: open ? "initial" : "center",
                          paddingRight: !open ? 3 : 0,
                        }}
                      >
                        {route.icon}
                      </ListItemIcon>
                    )}
                    {open && (
                      <ListItemText
                        primary={route.name}
                        sx={{ mr: 2 }}
                      />
                    )}
                    {open && route.status?.length > 0 && (
                      <Box
                        sx={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: 2,
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: -10,
                            right: -8,
                            background: "red",
                            color: "white",
                            borderRadius: "4px",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                          }}
                        >
                          {route.status.length}
                        </div>
                      </Box>
                    )}
                  </Box>
                </CustomListItem>
              ))}
            </List>
          </div>
        ))}
      </ScrollableList>
    </>
  );

  return (
    // <Box sx={{ display: "flex", width: "100%" }}>
    <Box sx={{ display: "flex", width: "100vw", minHeight: "100vh", overflowX: !open?"hidden":"auto"}}>
      <CssBaseline />
      <Navbar open={open} handleDrawerOpen={handleDrawerToggle} />
      {isMobile ? (
        <Drawer
          anchor="left"
          variant="temporary"
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': {
              width: drawerWidth,
            },
          }}
        >
          {renderDrawerContent()}
        </Drawer>
      ) : (
        <PermanentDrawer variant="permanent" open={open}>
          {renderDrawerContent()}
        </PermanentDrawer>
      )}
      <Box component="main" sx={{ flexGrow: 1, p: 5, width: "100%" }}>
        <DrawerHeader />
        <Outlet />
      </Box>
    </Box>
  );
}

